import { Reveal } from "./Reveal";

export default function SectionHeading({ kicker, title, subtitle, light = false, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal>
      <div className={`flex flex-col ${alignCls} max-w-2xl gap-4`}>
        {kicker && (
          <span
            className={`text-xs sm:text-sm tracking-[0.22em] uppercase font-semibold ${
              light ? "text-gold-light" : "text-gold-dark"
            }`}
            data-testid="section-kicker"
          >
            {kicker}
          </span>
        )}
        <h2
          className={`font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.05] ${
            light ? "text-cream" : "text-plum"
          }`}
        >
          {title}
        </h2>
        {subtitle && (
          <p className={`text-base sm:text-lg leading-relaxed ${light ? "text-cream/80" : "text-stone"}`}>
            {subtitle}
          </p>
        )}
      </div>
    </Reveal>
  );
}
